import { valueof } from '.';

// BADGE
export const BadgeKind = {
  DOT: 'dot',
  NOTIFICATION: 'notification'
} as const;

export type CommonBadgeProps = {
  background: string,
  border?: string,
  size: string
};

export const BadgeBackgroundColor = {
  BLACK: 'background-black',
  WHITE: 'background-white',
  INFORMATION: 'background-information',
  SUCCESS: 'background-success',
  CAUTION: 'background-caution',
  ERROR: 'background-error',
  BROWN: 'background-brown',
  YELLOW: 'background-yellow'
} as const;

export type BadgeBackgroundColorType = valueof<typeof BadgeBackgroundColor>;

export const BadgeBorderColor = {
  BLACK: 'border-black',
  WHITE: 'border-white',
  GREY: 'border-grey',
  INFORMATION: 'border-information',
  SUCCESS: 'border-success',
  CAUTION: 'border-caution',
  ERROR: 'border-error'
} as const;

export type BadgeBorderColorType = valueof<typeof BadgeBorderColor>;

// NOTIFICATION BADGE
export const NotificationBadgeSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
} as const;

export type NotificationBadgeSizeType = valueof<typeof NotificationBadgeSize>;

// DOT BADGE
export const DotBadgeSize = {
  SMALL: 'small',
  MEDIUM: 'medium'
} as const;

export const NotificationBadgeLayout = {
  ICON: 'icon',
  LABEL: 'label'
} as const;

export type NotificationBadgeLayoutType = valueof<typeof NotificationBadgeLayout>;

export type NotificationBadgeProps = {
  type: typeof BadgeKind.NOTIFICATION,
  size: NotificationBadgeSizeType;
  layout?: NotificationBadgeLayoutType;
  background: BadgeBackgroundColorType;
  border?: BadgeBorderColorType;
  icon?: { url: string; alt: string };
  label?: string;
}

export type DotBadgeProps = {
  type: typeof BadgeKind.DOT,
  background: BadgeBackgroundColorType;
  border: BadgeBorderColorType;
  size: valueof<typeof DotBadgeSize>;
}
